"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-restricted-globals */
const moment_1 = __importDefault(require("moment"));
const lodash_1 = require("lodash");
const fast_xml_parser_1 = __importStar(require("fast-xml-parser"));
require("moment/min/locales");
const base_64_1 = require("base-64");
const getIntegerFromUnknown_1 = __importDefault(require("../../shared/getIntegerFromUnknown"));
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const orderByAccessor_1 = __importDefault(require("../../shared/orderByAccessor"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const sliceFormater = (originData, targetTypeDetail) => {
    if (typeof targetTypeDetail === 'string'
        && targetTypeDetail.includes(',')
        && targetTypeDetail.length >= 3) {
        const spl = targetTypeDetail.split(',');
        const start = (0, getIntegerFromUnknown_1.default)(spl[0]);
        const end = (0, getIntegerFromUnknown_1.default)(spl[1]);
        return originData.slice(start, end);
    }
    return originData.slice((0, getIntegerFromUnknown_1.default)(targetTypeDetail));
};
const callableGlobalFormatterBuilder = ({ encryptMD5, hmacSha256Base64, sha256, hmacSha256Hex, }) => async ({ entryVars: { originData, originType, originTypeDetail, targetType, targetTypeDetail, locale, }, callbacks, executeProcesses, functionId, processor, }) => {
    const lang = locale === 'spanish' ? 'es' : 'en-ca';
    const throwNoValidTarget = () => {
        processor.root.alert('Format error', `Not a valid target type; from ${originType} to ${targetType}, [origin: ${originData}]`);
    };
    let result;
    try {
        switch (originType) {
            case 'object':
                switch (targetType) {
                    case 'arrayWithId': {
                        if (typeof originData !== 'object') {
                            result = undefined;
                        }
                        else {
                            result = Object.entries(originData || {}).map(([id, entry]) => {
                                if (typeof entry === 'object') {
                                    return Object.assign(Object.assign({}, entry), { id });
                                }
                                return { entry, id };
                            });
                        }
                        break;
                    }
                    case 'arrayWithoutId': {
                        if (typeof originData !== 'object') {
                            result = undefined;
                        }
                        else {
                            result = Object.entries(originData || {}).map(([, entry]) => entry);
                        }
                        break;
                    }
                    case 'set': {
                        let newOriginData;
                        if (typeof originTypeDetail === 'number') {
                            if (Array.isArray(originData)) {
                                newOriginData = originData;
                            }
                            else if (typeof originData === 'object' && originData !== null) {
                                newOriginData = originData;
                            }
                            else {
                                newOriginData = [];
                            }
                        }
                        else if (typeof originData === 'object' && originData !== null) {
                            newOriginData = originData;
                        }
                        else {
                            newOriginData = {};
                        }
                        if (typeof originTypeDetail !== 'number'
                            && typeof originTypeDetail !== 'string'
                            && !Array.isArray(originTypeDetail)) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = (0, lodash_1.set)(newOriginData, originTypeDetail, targetTypeDetail);
                        }
                        break;
                    }
                    case 'get':
                        if (typeof originTypeDetail !== 'number'
                            && typeof originTypeDetail !== 'string'
                            && !Array.isArray(originTypeDetail)) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = (0, lodash_1.get)(originData, originTypeDetail);
                        }
                        break;
                    case 'concatObjects': {
                        if ((0, valueIsRecord_1.default)(originData) && (0, valueIsRecord_1.default)(originTypeDetail)) {
                            result = Object.assign(Object.assign({}, originData), originTypeDetail);
                        }
                        else {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    }
                    case 'jsonStringify':
                        if (!(0, valueIsRecord_1.default)(originData) && !(0, valueIsArray_1.default)(originData)) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = JSON.stringify(originData);
                        }
                        break;
                    default:
                        throwNoValidTarget();
                        result = undefined;
                }
                break;
            case 'array':
                switch (targetType) {
                    case 'contactArrays':
                        if (!Array.isArray(originData)
                            || !Array.isArray(originTypeDetail)) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = [...originData, ...originTypeDetail];
                        }
                        break;
                    case 'slice': {
                        if (!Array.isArray(originData)
                            || (typeof targetTypeDetail !== 'string' && typeof targetTypeDetail !== 'number')) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = sliceFormater(originData, targetTypeDetail);
                        }
                        break;
                    }
                    case 'orderBy': {
                        if ((0, valueIsRecord_1.default)(originData) || (0, valueIsArray_1.default)(originData)) {
                            const arrayData = (0, valueIsRecord_1.default)(originData)
                                ? Object.values(originData) : originData;
                            if (!(0, valueIsString_1.default)(originTypeDetail)) {
                                result = arrayData.sort();
                            }
                            else {
                                result = (0, orderByAccessor_1.default)(arrayData, (recordValue) => {
                                    if ((0, valueIsRecord_1.default)(recordValue)) {
                                        return recordValue[originTypeDetail];
                                    }
                                    return undefined;
                                });
                            }
                        }
                        else {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    }
                    default:
                        throwNoValidTarget();
                        result = undefined;
                }
                break;
            case 'number':
                switch (targetType) {
                    case 'hexadecimal': {
                        try {
                            const originNumber = (0, getNumberFromUnknown_1.default)(originData);
                            result = originNumber.toString(16).toUpperCase();
                        }
                        catch (_a) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    }
                    case 'round':
                        {
                            const originNumber = Number(originData);
                            if (isNaN(originNumber)) {
                                throwNoValidTarget();
                                result = undefined;
                            }
                            else {
                                result = Math.round(originNumber);
                            }
                        }
                        break;
                    case 'moneyNumber':
                    case 'money':
                        {
                            const originNumber = Number(originData);
                            if (isNaN(originNumber)) {
                                throwNoValidTarget();
                                result = undefined;
                            }
                            else {
                                const currency = targetType === 'moneyNumber' ? '' : (targetTypeDetail || '$');
                                const number = originNumber.toFixed(2);
                                result = `${currency}${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
                            }
                        }
                        break;
                    case 'string':
                        {
                            const originNumber = Number(originData);
                            if (isNaN(originNumber)) {
                                throwNoValidTarget();
                                result = undefined;
                            }
                            else {
                                result = originNumber.toString();
                            }
                        }
                        break;
                    default:
                        throwNoValidTarget();
                        result = undefined;
                }
                break;
            case 'string':
                switch (targetType) {
                    case 'noSpaces':
                        result = `${originData}`.replace(/\s/g, '');
                        break;
                    case 'trimmed':
                        result = `${originData}`.replace(/^\s*/, '').replace(/\s*$/, '');
                        break;
                    case 'slice': {
                        if (typeof originData !== 'string'
                            || (typeof targetTypeDetail !== 'string' && typeof targetTypeDetail !== 'number')) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = sliceFormater(originData, targetTypeDetail);
                        }
                        break;
                    }
                    case 'titleCase': {
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = originData.replace(/(^|\s)\S/g, (value) => value.toUpperCase());
                        }
                        break;
                    }
                    case 'split': {
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            const separator = `${originTypeDetail}` || '';
                            result = originData.split(separator);
                        }
                        break;
                    }
                    case 'hexaEncoding': {
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            const encodeData = unescape(encodeURIComponent(originData));
                            result = '';
                            for (let i = 0; i < encodeData.length; i += 1) {
                                result += encodeData.charCodeAt(i).toString(16).toUpperCase();
                            }
                        }
                        break;
                    }
                    case 'MD5': {
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = encryptMD5(originData);
                        }
                        break;
                    }
                    case 'base64': {
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = (0, base_64_1.encode)(originData);
                        }
                        break;
                    }
                    case 'replace': {
                        if (typeof originData !== 'string'
                            || typeof originTypeDetail !== 'string'
                            || typeof targetTypeDetail !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = originData.replace(originTypeDetail, targetTypeDetail);
                        }
                        break;
                    }
                    case 'replaceAll': {
                        if (typeof originData !== 'string'
                            || typeof originTypeDetail !== 'string'
                            || typeof targetTypeDetail !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = originData.split(originTypeDetail).join(targetTypeDetail);
                        }
                        break;
                    }
                    case 'number':
                        try {
                            result = (0, getNumberFromUnknown_1.default)(originData);
                        }
                        catch (_b) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    case 'lowerCase': {
                        if (typeof originData === 'string') {
                            result = originData.toLowerCase();
                        }
                        else {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    }
                    case 'upperCase': {
                        if (typeof originData === 'string') {
                            result = originData.toUpperCase();
                        }
                        else {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    }
                    case 'sha256': {
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = await sha256(originData);
                        }
                        break;
                    }
                    case 'hmacSha256': {
                        if (!(0, valueIsString_1.default)(originData) || !(0, valueIsString_1.default)(targetTypeDetail)) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = await hmacSha256Base64(originData, targetTypeDetail);
                        }
                        break;
                    }
                    case 'hmacSha256Hex':
                        if (!(0, valueIsString_1.default)(originData) || !(0, valueIsString_1.default)(targetTypeDetail)) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = await hmacSha256Hex(originData, targetTypeDetail);
                        }
                        break;
                    case 'jsonParse':
                        if (!(0, valueIsString_1.default)(originData)) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = JSON.parse(originData);
                        }
                        break;
                    default:
                        throwNoValidTarget();
                        result = undefined;
                }
                break;
            case 'date':
                switch (targetType) {
                    case 'date': {
                        if (typeof originData !== 'string'
                            && typeof originData !== 'number'
                            && !(originData instanceof Date)
                            && originData !== undefined) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else if (typeof originTypeDetail !== 'string'
                            && originTypeDetail !== undefined) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else if (typeof targetTypeDetail !== 'string'
                            && targetTypeDetail !== undefined) {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            moment_1.default.locale(lang);
                            const originDate = (0, moment_1.default)(originData, originTypeDetail);
                            result = originDate.format(targetTypeDetail);
                        }
                        break;
                    }
                    default:
                        throwNoValidTarget();
                        result = undefined;
                }
                break;
            case 'json': {
                switch (targetType) {
                    case 'xml': {
                        if (typeof originData === 'string') {
                            const defaultOptions = {
                                attributeNamePrefix: '@_',
                                attrNodeName: '@',
                                textNodeName: '#text',
                                ignoreAttributes: true,
                                cdataTagName: '__cdata',
                                cdataPositionChar: '\\c',
                                format: false,
                                indentBy: '  ',
                                supressEmptyNode: false,
                            };
                            const parse = new fast_xml_parser_1.j2xParser(defaultOptions);
                            result = parse.parse(JSON.parse(originData));
                        }
                        else {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    }
                    default: {
                        result = undefined;
                    }
                }
                break;
            }
            case 'Base 64': {
                switch (targetType) {
                    case 'string': {
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = (0, base_64_1.decode)(originData);
                        }
                        break;
                    }
                    default: {
                        result = undefined;
                    }
                }
                break;
            }
            case 'xml': {
                switch (targetType) {
                    case 'json': {
                        if (typeof originData === 'string' && fast_xml_parser_1.default.validate(originData) === true) {
                            const defaultOptions = {
                                attributeNamePrefix: '@_',
                                attrNodeName: '@',
                                textNodeName: '#text',
                                ignoreAttributes: true,
                                cdataTagName: '__cdata',
                                cdataPositionChar: '\\c',
                                format: false,
                                indentBy: '  ',
                                supressEmptyNode: false,
                            };
                            result = fast_xml_parser_1.default.parse(originData, defaultOptions);
                        }
                        else {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        break;
                    }
                    default: {
                        result = undefined;
                    }
                }
                break;
            }
            case 'HTML':
                switch (targetType) {
                    case 'string':
                        if (typeof originData !== 'string') {
                            throwNoValidTarget();
                            result = undefined;
                        }
                        else {
                            result = originData.replace(/(<([^>]+)>)/ig, '');
                        }
                        break;
                    default:
                        throwNoValidTarget();
                        result = undefined;
                }
                break;
            default:
                processor.root.alert('Format error', `Not a valid origin type: ${originType}`);
                result = undefined;
        }
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeProcesses(functionId, callbacks.error, errorMessage);
        return undefined;
    }
    executeProcesses(functionId, callbacks.success, result);
    return result;
};
exports.default = callableGlobalFormatterBuilder;
